import { isNil } from 'lodash-es'
import { useEffect, useState } from 'react'

export const useUserLocalConfig = () => useLocalStorage('user.config', { tester: false })

const migrateKey = (oldKey: string, newKey: string): void => {
  const old = localStorage.getItem(oldKey)
  if (old && !localStorage.getItem(newKey)) {
    localStorage.setItem(newKey, old)
    localStorage.removeItem(oldKey)
  }
}

export const migratePerformanceStatsStorageKeys = (): void => {
  migrateKey('costDetails.filters', 'performanceStats.filters')
  migrateKey('costDetails.widgets', 'performanceStats.widgets')
}

const getStorageValue = <T>(key: string, defaultValue: T): T => {
  migratePerformanceStatsStorageKeys()
  const saved = localStorage.getItem(key)
  const localStorageValue = !isNil(saved) ? JSON.parse(saved) : {}
  return { ...defaultValue, ...localStorageValue }
}

export const useLocalStorage = <T>(
  key: string,
  defaultValue: T,
  excludeSubKeys: string[] = []
): [value: T, setValue: (newValue: T) => void] => {
  const [value, setValue] = useState(() => getStorageValue(key, defaultValue))

  useEffect(() => {
    const valueToStore = { ...value } as Record<string, unknown>
    excludeSubKeys.forEach((k) => {
      delete valueToStore[k]
    })
    localStorage.setItem(key, JSON.stringify(valueToStore))
  }, [key, value])

  return [value, setValue]
}

export const removePerformanceStatsFilters = (): void => {
  // To avoid bug if user is admin and change resellerId field in filters from '/home/report' and then connect with a normal user.
  localStorage.removeItem('costDetails.filters')
  localStorage.removeItem('performanceStats.filters')
}
